// Make collapse "toggle header" triggers keyboard-operable.
//
// Toggle cards are written with a non-button trigger — e.g. `%h3.sa-toggle-link{
// 'data-bs-toggle': 'collapse' }` — across the estate. Bootstrap toggles them on click, but a
// heading (or any non-button) takes no keyboard focus and is not operable by Enter or Space, so
// a keyboard user cannot open or close the card — WCAG 2.1.1 Keyboard, level A
// (CU-1248uf3wvrf / CU-1248uf3uw90).
//
// This gives every such trigger button semantics (role=button + tabindex=0) and activates it on
// Enter/Space, without changing the hundreds of call sites. Bootstrap's own click handler (bound
// to [data-bs-toggle="collapse"]) does the actual toggling and keeps aria-expanded in sync.

const SELECTOR = '.sa-toggle-link[data-bs-toggle="collapse"]'

const onKeydown = (event) => {
  if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
    // Space would otherwise scroll the page; Enter on a non-anchor would do nothing.
    event.preventDefault()
    event.currentTarget.click()
  }
}

const initToggleHeaderKeyboard = (container = document) => {
  container.querySelectorAll(SELECTOR).forEach((el) => {
    // A real <button> is already focusable and operable; leave it alone. The data-attribute
    // guard keeps this idempotent across repeated turbo:load / frame-load runs.
    if (el.tagName === 'BUTTON' || el.dataset.saToggleKeyboard === 'ready') return
    el.dataset.saToggleKeyboard = 'ready'

    if (!el.hasAttribute('role')) el.setAttribute('role', 'button')
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0')

    el.addEventListener('keydown', onKeydown)
  })
}

// turbo:load fires once on the initial load even with Turbo Drive disabled (as it is in the host
// apps), and again on every Turbo Drive visit if it is ever enabled.
document.addEventListener('turbo:load', () => initToggleHeaderKeyboard())

// Toggle headers rendered into a Turbo Frame after load.
document.addEventListener('turbo:frame-load', (event) => initToggleHeaderKeyboard(event.target))
